import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 place-items-center sm:p-4" }
const _hoisted_2 = { class: "flex flex-col sm:w-3/4 w-full gap-4 h-screen" }
const _hoisted_3 = { class: "flex flex-col sm:flex-row sm:items-center justify-between gap-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-semibold" }, "Mensajes", -1)
const _hoisted_5 = { class: "flex flex-row items-center gap-4" }
const _hoisted_6 = { class: "flex flex-col rounded-md shadow-lg overflow-auto gap-4" }
const _hoisted_7 = { class: "border-collapse mt-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-8 text-left py-4 border-b border-gray-300" }, "N°"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-8 text-left py-4 border-b border-gray-300" }, " Asunto "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-8 text-left py-4 border-b border-gray-300" }, " Destinatario "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-8 text-left py-4 border-b border-gray-300" }, " Fecha de envío "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-8 text-center py-4 border-b border-gray-300" }, " Acción ")
  ])
], -1)
const _hoisted_9 = { class: "px-8 py-4 text-right" }
const _hoisted_10 = { class: "px-8 py-4 text-left text-gray-700" }
const _hoisted_11 = { class: "flex flex-row gap-2 items-center" }
const _hoisted_12 = { class: "px-8 py-4 text-left relative" }
const _hoisted_13 = {
  key: 0,
  class: "font-semibold text-gray-800"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "px-8 py-4 text-left" }
const _hoisted_16 = { class: "px-8 py-4 text-center" }
const _hoisted_17 = { class: "flex flex-row items-center justify-center gap-4" }
const _hoisted_18 = { class: "flex flex-row gap-4 w-full" }

import { ref, onMounted, watch } from "vue";
import { storeToRefs } from "pinia";

import useNotificationStore from "@/stores/notification";
import PaginationControl from "@/components/atoms/PaginationControl.vue";
import Dropdown from "@/components/atoms/Dropdown.vue";

import MessageModal from "@/components/organisms/MessageModal.vue";
import UploadMessageFileModal from "@/components/organisms/UploadMessageFileModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageListView',
  setup(__props) {

const notificationStore = useNotificationStore();
const messageModal = ref<boolean>(false);
const uploadModal = ref<boolean>(false);

const { messageList, pagination } = storeToRefs(notificationStore);

onMounted(() => {
  notificationStore.getIndex();
});

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn h-[35px] whitespace-nowrap",
            onClick: _cache[0] || (_cache[0] = () => (messageModal.value = true))
          }, [
            _createVNode(_component_mdicon, { name: "email" }),
            _createTextVNode(" Enviar mensaje ")
          ]),
          _createElementVNode("button", {
            class: "btn h-[35px] whitespace-nowrap",
            onClick: _cache[1] || (_cache[1] = () => (uploadModal.value = true))
          }, [
            _createVNode(_component_mdicon, { name: "file" }),
            _createTextVNode(" Carga masiva ")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messageList), (message, messageIndex) => {
              return (_openBlock(), _createElementBlock("tr", { key: messageIndex }, [
                _createElementVNode("td", _hoisted_9, _toDisplayString(+messageIndex + 1), 1),
                _createElementVNode("td", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    (message.files && message.files.length > 0)
                      ? (_openBlock(), _createBlock(_component_mdicon, {
                          key: 0,
                          name: "file-multiple",
                          size: "18",
                          alt: "Tiene archivos adjuntos"
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(message.subject ?? "-"), 1)
                  ])
                ]),
                _createElementVNode("td", _hoisted_12, [
                  (message.isSendedAllShareholders)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, " A todos los miembros "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.sendingShareholder.slice(0, 5), (shareholder, shareholderIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "flex flex-row flex-wrap gap-2 text-wrap",
                            key: shareholderIndex
                          }, _toDisplayString(shareholder.shareholder?.accountOwnerName ?? "-") + _toDisplayString(shareholderIndex > 0 ? "," : ""), 1))
                        }), 128)),
                        _createTextVNode(" " + _toDisplayString(message.sendingShareholder > 5 ? "Mas..." : ""), 1)
                      ]))
                ]),
                _createElementVNode("td", _hoisted_15, _toDisplayString(new Date(message.createdAt).toLocaleDateString("es-CL") ?? "-"), 1),
                _createElementVNode("td", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_RouterLink, {
                      to: { name: 'message-id', params: { id: message.id } },
                      class: "hover:scale-110 transition-all"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_mdicon, {
                          name: "eye",
                          class: "text-gray-600"
                        })
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(PaginationControl, {
          selectedPage: _unref(pagination).page,
          "per-page": _unref(pagination).perPage,
          "total-pages": _unref(pagination).totalPages,
          onSetPage: _cache[2] || (_cache[2] = 
            (page) => {
              _unref(pagination).page = page;
              _unref(notificationStore).getIndex();
            }
          )
        }, null, 8, ["selectedPage", "per-page", "total-pages"])
      ])
    ]),
    _createVNode(MessageModal, {
      visible: messageModal.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = 
        async () => {
          messageModal.value = !messageModal.value;
          await _unref(notificationStore).getIndex();
        }
      )
    }, null, 8, ["visible"]),
    _createVNode(UploadMessageFileModal, {
      visible: uploadModal.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = 
        async () => {
          uploadModal.value = !uploadModal.value;
          await _unref(notificationStore).getIndex();
        }
      )
    }, null, 8, ["visible"])
  ]))
}
}

})